<template>
  <div class="phonefind">
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      :rules="rule"
      label-width="150px"
      class="demo-ruleForm"
      v-show="phonefirstStap"
    >
      <div class="content">
        <div class="formLeft">
          <el-form-item
            :label="$t('forgectPhone.phone')"
            prop="phone"
          >
            <el-input
              v-model="ruleForm.phone"
              class="inputsty"
              :placeholder="$t('forgectPhone.phoneplace')"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="content posit">
        <div class="formLeft">
          <drag-verify
            :width="316"
            :height="40"
            handlerIcon="el-icon-d-arrow-right"
            successIcon="el-icon-check"
            :text="$t('forgectPhone.drag')"
            :success-text="$t('forgectPhone.check')"
            background="#ddd"
            progress-bar-bg="#2ACBF8"
            text-size="14px"
            :circle="true"
            ref="Verify"
          >
          </drag-verify>
        </div>
      </div>
    </el-form>
    <el-form
      :model="ruleFormnext"
      ref="ruleFormnext"
      :rules="rulenext"
      :label-width="this.$i18n.locale=='en'?'250px':'150px'"
      class="demo-ruleForm"
      v-show="!phonefirstStap"
    >
      <div>
        {{$t('forgectPhone.text')}}
        <span>{{ telphone.substr(0, 3) + "****" + telphone.substr(7) }}</span>
      </div>
      <br />
      <div class="content">
        <div class="formLeft">
          <el-form-item
            :label="$t('forgectPhone.phonecode')"
            prop="code"
          >
            <el-input
              v-model="ruleFormnext.code"
              class="picwid"
              :placeholder="$t('forgectPhone.phonetext')"
            ></el-input>
            <div class="codewid">
              <el-button
                type="success"
                @click="phonesendCode"
              >{{
                 codeStr
                }}</el-button>
            </div>
          </el-form-item>
        </div>
      </div>
      <div class="content">
        <div class="formLeft">
          <el-form-item
            :label="$t('forgectPhone.passwords')"
            prop="passwords"
          >
            <el-input
              v-model="ruleFormnext.passwords"
              class="inputsty"
              v-popover:popovers
              type="password"
              :placeholder="$t('forgectPhone.passwordText')"
            ></el-input>
            <el-popover
              ref="popovers"
              placement="right"
              width="30"
              trigger="focus"
              content=""
            >
            <p v-for="(item,index) in $t('forgectPhone.popovers')" :key="index">
              {{item.name}}
            </p>
            </el-popover>
          </el-form-item>
        </div>
      </div>
      <div class="content">
        <div class="formLeft">
          <el-form-item
            :label="$t('forgectPhone.rePasswords')"
            prop="rePasswords"
          >
            <el-input
              v-model="ruleFormnext.rePasswords"
              class="inputsty"
              type="password"
              v-popover:popoversr
              :placeholder="$t('forgectPhone.rePasswordsText')"
            ></el-input>
            <el-popover
              ref="popoversr"
              placement="right"
              width="30"
              trigger="focus"
              content=""
            >
              <p>{{$t('forgectPhone.popoversr')}}</p>
            </el-popover>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <div class="elbtn">
      <el-button
        @click="nextTap('ruleForm')"
        class="rightBtn"
        style="margin-top:70px;"
        type="success"
        size="medium"
        v-if="phonefirstStap"
      >{{$t('forgectPhone.next')}}</el-button>
      <el-button
        v-else
        @click="submit('ruleFormnext')"
        class="rightBtn"
        type="success"
        size="medium"
      >{{$t('forgectPhone.define')}}</el-button>
    </div>
    <!-- 点击下一步提示弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="24%"
      center
    >
      <img
        style="width:60px;height:60px;"
        src="../../assets/img/right.png"
        alt=""
      />
      <div>{{$t('forgectPhone.nonebind')}}</div>
    </el-dialog>
    <!-- 修改成功弹窗 -->
    <el-dialog
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <img
        style="width:60px;height:60px;"
        src="../../assets/img/right.png"
        alt=""
      />
      <div style="margin-top:10px;">{{$t('forgectPhone.passwordsuccess')}}</div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          size="medium"
          type="success"
          @click="backlogin"
        >{{$t('forgectPhone.back')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import dragVerify from "vue-drag-verify";
export default {
  components: {
    dragVerify
  },
  data() {
    var loginPass = (rule, value, callback) => {
      var rest = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{6,}$/;
      if (
        !rest.test(value) ||
        !value ||
        value.length < 6 ||
        value.length > 20
      ) {
        return callback(new Error(this.$t('checkvalid.password')));
      } else {
        callback();
      }
    };
    var phonevalid = (rule, value, callback) => {
      var rest = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (!rest.test(value) || value == 0) {
        return callback(new Error(this.$t('checkvalid.phone')));
      } else {
        callback();
      }
    };
    var rePass = (rule, value, callback) => {
      var rest = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{6,}$/;
      if (
        !rest.test(value) ||
        !value ||
        value.length < 6 ||
        value.length > 20
      ) {
        return callback(new Error(this.$t('checkvalid.password')));
      } else if (value !== this.ruleFormnext.passwords) {
        callback(new Error(this.$t('checkvalid.same')));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        phone: "" //本人绑定手机号
      },
      rule: {
        phone: [{ required: true, validator: phonevalid, trigger: "blur" }]
      },
      ruleFormnext: {
        passwords: "",
        rePasswords: "",
        code: ""
      },
      rulenext: {
        passwords: [{ required: true, validator: loginPass, trigger: "blur" }],
        code: [{ required: true, message: this.$t('checkvalid.code'), trigger: "blur" }],
        rePasswords: [{ required: true, validator: rePass, trigger: "blur" }]
      },
      codeStr: this.$t('forgectPhone.codeStr'),
      phonefirstStap: true,
      dialogVisible: false,
      centerDialogVisible: false,
      telphone: "",
      yanzheng: false
    };
  },
  created() {
    this.phonefirstStap = true;
  },
  methods: {
    nextTap() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (!this.$refs.Verify.isPassing) {
            this.$message({
              message: this.$t('checkvalid.hd'),
              type: "warning"
            });
            return false;
          } else {
            this.phonefirstStap = false;
            this.telphone = this.ruleForm.phone;
          }
        } else {
          console.log("error submit!!");
          return;
        }
      });
    },
    submit() {
      this.$refs.ruleFormnext.validate(valid => {
        if (valid) {
          const data = {
            phone: this.telphone,
            code: this.ruleFormnext.code,
            password: this.ruleFormnext.passwords
          };
          this.$http
            .post("/login/phone_find_pass", data)
            .then(res => {
              console.log(res);
              if (res.status == 200) {
                if (res.data.status == 0) {
                  this.centerDialogVisible = true;
                } else {
                  this.$message({
                    message: res.data.error,
                    type: "warning",
                    duration: 1500
                  });
                  return;
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return;
        }
      });
    },
    // 注册成功后登录
    backlogin() {
      this.centerDialogVisible = false;
      this.$router.push({
        name: "login"
      });
    },
    // 发验证码
    phonesendCode() {
      let that = this;
      let times = 60;
      const data = {
        phone: this.telphone
      };
      this.$http
        .post("/common/get_phone_code", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              this.$message({
                message: this.$t('checkvalid.codesuccess'),
                type: "success",
                duration: 1500
              });
              let timer = setInterval(() => {
                --times;
                that.codeStr = times + "S";
                if (times == 0) {
                  this.codeStr = this.$t('forgectPhone.codeStr');
                  clearInterval(timer);
                }
              }, 1000);
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
              return;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 发送验证码
    codeBinds() {
      const data = {
        phone: this.telphone
      };
      this.$http
        .post("/common/get_phone_code", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              this.$message({
                message: this.$t('checkvalid.codesuccess'),
                type: "success",
                duration: 1500
              });
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
              return;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style lang="scss">
.phonefind {
  .codewid {
    margin-left: 25px;
  }
  .drag_verify {
    margin-bottom: 20px !important;
  }
}
</style>
